import React, { Suspense, lazy } from 'react';

const Banner = lazy(() => import('./Components/Banner'));
const About = lazy(() => import('./Components/About'));
const Projects = lazy(() => import('./Components/Projects'));
const Unique = lazy(() => import('./Components/Unique'));
const Random = lazy(() => import('./Components/Random'));
const Stats = lazy(() => import('./Components/Stats'));
const VR = lazy(() => import('./Components/VR'));
const Location = lazy(() => import('./Components/Location'));
const Carosel = lazy(() => import('./Components/Carosel'));
const SecondStat = lazy(() => import('./Components/SeconStat'))
function Index() {
  return (
    <div className="w-full m-0 p-0">
      <Suspense fallback={<div>Loading...</div>}>
        <Banner />
      </Suspense>

      {/* Load other components progressively */}
      <Suspense fallback={<div>Loading Unique...</div>}>
        <Unique />
      </Suspense>

      <Suspense fallback={<div>Loading Carosel...</div>}>
        <Carosel />
      </Suspense>

      <Suspense fallback={<div>Loading About...</div>}>
        <About />
      </Suspense>

      <Suspense fallback={<div>Loading Projects...</div>}>
        <Projects />
      </Suspense>

      <Suspense fallback={<div>Loading VR...</div>}>
        <VR />
      </Suspense>

      <Suspense fallback={<div>Loading Stats...</div>}>
        <Stats />
      </Suspense>

      <Suspense fallback={<div>Loading Stats...</div>}>
        <SecondStat />
      </Suspense>

      <Suspense fallback={<div>Loading Location...</div>}>
        <Location />
      </Suspense>

      <Suspense fallback={<div>Loading Random...</div>}>
        <Random />
      </Suspense>
    </div>
  );
}

export default Index;
